export const SET_CURRENT_PAGE = 'SetCurrentPage';
export const SET_CURRENT_PAGE_TITLE = 'SetCurrentPageTitle';
export const TOGGLE_MOBILE_NAV_VIEW = 'ToggleMobileNavView';








